module.exports = __webpack_public_path__ + "first-200_paper.jpg?fc633019de20854680bdfcf0cf9738ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-200_paper.jpg
// module id = 488
// module chunks = 0